/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Cancel_Sync_ButtonInputs */



/**
* | output |
* | --- |
* | "Cancel Sync" |
*
* @param {Snapshot_History_Cancel_Sync_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_cancel_sync_button = /** @type {((inputs?: Snapshot_History_Cancel_Sync_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Cancel_Sync_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cancel Sync")
	if (locale === "de") return /** @type {LocalizedString} */ ("Cancel Sync")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancel Sync")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Cancel Sync")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cancel Sync")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Cancel Sync")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Cancel Sync")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Cancel Sync")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cancel Sync")
	return /** @type {LocalizedString} */ ("Cancel Sync")
});